import React, { useState, useEffect } from "react";
import axios from "axios";
import {  useParams } from "react-router-dom";
// Components
import Preloader from "../../../components/Preloader/Preloader";

import MUIDataTable from "mui-datatables";

//Date Range
import { addDays, format } from "date-fns";
import { DateRangePicker } from "materialui-daterange-picker";

// Material UI Component
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	// Grid,
	// Select,
	Input,
	InputLabel,
	// MenuItem,
	Modal,
	Backdrop,
	Fade,
	// fade,
	Button,
	Grid,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
// Material Icons
// import { AssessmentTwoTone, FaceRounded } from "@material-ui/icons";
import { AssessmentTwoTone } from "@material-ui/icons";

import { NavLink } from "react-router-dom";
//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";

const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",
	},
	// textField: {
    //     marginTop: '-15px',
	// },
	// whiteContainer : {
	// 	background: '#FCFCFC',
	// 	padding: '1em',
	// 	marginBottom: '1.5em',
	// 	borderRadius: '0.75em',
	// }

	// paper: {
	// 	backgroundColor: theme.palette.background.paper,
	// 	border: "2px solid #000",
	// 	boxShadow: theme.shadows[5],
	// 	padding: theme.spacing(2, 4, 3),
	// },
}));

const DRReturnDetails = () => {
	const [dataLoaded, setDataLoaded] = useState(false);
	// const [DRRetDetails, setDRRetDetails] = useState();
	const [DRRetDetails, setDRRetDetails] = useState([]);
	// const [posts, setPosts] = useState([]);
	const classes = useStyles();
	// const { id } = useParams();
	const { drretno } = useParams();

	const [open, setOpen] = useState(false);
	const [modalOpen, setModalOpen] = useState(false);

	// Data Fetching
	useEffect(() => {
		data(); 
	}, []);
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);
	const data = async () => {
		//get data from api (for table)
		setDataLoaded(false);
		if(drretno !== ''){
			const result = await axios.get(process.env.REACT_APP_API_URL+'/get_drreturn', {
				params:{
                    // idno: id,
					// id: id,
					drretno: drretno,
				}
			})
			//setPosts(result.data.data);
			//render data in readonly form instead
			console.log(result.data.data);
			setDRRetDetails(result.data.data);
			setDataLoaded(true);
		}
	};

	const toggle = () => setOpen(!open);

	const handleModalOpen = () => {
		setModalOpen(true);
	};

	const handleModalClose = () => {
		setModalOpen(false);
	};

	const columns = [
		{
			name: "drretno",
			label: "DR Ret No.",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "drno",
			label: "DR No",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "idno",
			label: "ID No.",
			options: {
				filter: false,
				// display: "excluded",
			},
		},
		{
			name: "isgood",
			label:"Is Good",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "rtype",
			label:"Return Type",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "itemlocid",
			label:"Item Location ID",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "itemid",
			label:"Item ID",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "retqty",
			label:"Return Quantity",
			options: {
				filter: false,
				setCellProps: value => ({ style: { textAlign: 'right' } }),
				// display: "excluded",
			}
		},
		{
			name: "drprice",
			label:"DR Price",
			options: {
				filter: false,
				setCellProps: value => ({ style: { textAlign: 'right' } }),
				// display: "excluded",
			}
		},
		{
			name: "totalamt",
			label:"Total Amount",
			options: {
				filter: false,
				setCellProps: value => ({ style: { textAlign: 'right' } }),
				// display: "excluded",
			}
		},
		{
			name: "trandate",
			label:"Transaction Date",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "rcvby",
			label:"Receive By",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "approver",
			label:"Approver",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "notes",
			label:"Notes",
			options: {
				filter: false,
				// display: "excluded",
			}
		},
		{
			name: "status",
			label:"Status",
			options: {
				filter: false,
				// setCellProps: value => ({ style: { textAlign: 'right' } }),
				// display: "excluded",
			}
		},
		{
			name: "branchidno",
			label:"Branch ID No.",
			options: {
				filter: false,
				// display: "excluded",
			}
		}
	];

	const options = {
		filter: true,
		// filterType: "dropdown",
		selectableRows: "none",
		filterType: "multiselect",
		responsive: "standard",
		setFilterChipProps: (colIndex, colName, data) => {
			console.log(colIndex, colName, data);
			return {
				color: "primary",
				variant: "outlined",
				className: "testClass123",
			};
		},
		// tableBodyHeight,
	};
	
    const style = {
		marginBottom: '1rem',
		marginTop:"2.5em",
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<AssessmentTwoTone />
				</div>
				<NavLink to={"/reports"}><h4 style={{color:"#339933"}}>Reports</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4 className="header-title">DR Return Details</h4>
			</div>
			<div className="page-container">
			{!dataLoaded ? (
				<Preloader />
			) : (
				<MUIDataTable
					title={
						<div>
					
							<div className="table-title">
							DR Return Details
							</div>
						</div>
					}
					data={DRRetDetails}
					columns={columns}
					options={options}
				/>
			)}
			</div>
		</div>
	);
};

export default DRReturnDetails;
